module.exports = __webpack_public_path__ + "img/selected-motorcycle.70b5bdbd.png";